import { render, staticRenderFns } from "./MarketingTeaser.vue?vue&type=template&id=11397b82&scoped=true"
import script from "./MarketingTeaser.vue?vue&type=script&lang=js"
export * from "./MarketingTeaser.vue?vue&type=script&lang=js"
import style0 from "./MarketingTeaser.vue?vue&type=style&index=0&id=11397b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11397b82",
  null
  
)

export default component.exports